// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ProjectTwoToneSvg from "@fishx/icons-svg/es/asn/ProjectTwoTone";
import FishxIcon from '../components/FishxIcon';

var ProjectTwoTone = function ProjectTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ProjectTwoToneSvg
  }));
};

ProjectTwoTone.displayName = 'ProjectTwoTone';
export default React.forwardRef(ProjectTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ProjectTwoTone.js
// module id = 3860
// module chunks = 0